









































































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import AppForm from '@core/components/AppForm.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import { inject } from 'inversify-props'
import { IDateService } from '@master/services/IDateService'
import API from '@core/services/API'
import { isEmpty } from 'lodash'
import { UIService } from '@core/services/UIService'
import { SharedVariable } from '@core/model/SharedVariable'
import { UserAdviserDetailsMeta } from './model/UserAdviserDetailsMeta'
import EducationMeta from './model/EducationMeta'
import EmploymentMeta from './model/EmploymentMeta'
import QualificationMeta from './model/QualificationMeta'
import AppDialog from '@core/components/AppDialog.vue'

const userStore = namespace('UserStore')

@Component({
  components: {
    AppForm,
    AppDialog
  }
})
export default class TheEducation extends Vue {
  @inject()
  private $api: API

  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  @inject()
  private dateService: IDateService

  // @userAdviserDetailsStore.State
  // private userAdviserDetails!: UserAdviserDetails;

  @userStore.State
  private userAdviserDetails: UserAdviserDetailsMeta

  @userStore.Action
  private fetchAdviserDetails: (adviserOid: string) => Promise<void>

  private isModalEducation = false
  private isModalQualification = false
  private isModalEmployment = false

  private newEducation: EducationMeta = new EducationMeta()
  private newQualification: QualificationMeta = new QualificationMeta()
  private newEmployment: EmploymentMeta = new EmploymentMeta()

  get educationList (): EducationMeta[] {
    return this.userAdviserDetails.educationList
  }

  get employmentList (): EmploymentMeta[] {
    return this.userAdviserDetails.employmentList
  }

  get qualificationList (): QualificationMeta[] {
    return this.userAdviserDetails.qualificationList
  }

  get userOid (): string {
    return this.$route.params.userOid as string || this.$store.getters.currentUser.accountID
  }

  get isOpsStaff () {
    return this.$store.getters.currentUser.systemrole === 'ops-staff'
  }

  get EducationStructure (): FormStructure<EducationMeta> {
    return [
      {
        label: 'Name of Institution',
        key: 'nameOfInstitution'
      },
      {
        label: 'Location',
        key: 'location'
      },
      {
        label: 'From',
        key: 'dateFrom',
        type: 'date'
      },
      {
        label: 'To',
        key: 'dateTo',
        type: 'date'
      },
      {
        label: 'Certificate / Diploma / Degree Awarded',
        key: 'awarded',
        classes: ['colspan']
      }
    ]
  }

  get QualificationStructure (): FormStructure<QualificationMeta> {
    return [
      {
        label: 'Name of Qualification',
        key: 'nameOfQualification',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Attainment Basis',
        key: 'attainmentBasis',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Institution',
        key: 'institution',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Year Conferred',
        key: 'dateYearConferred',
        type: 'date',
        disabled: !this.isOpsStaff
      }
    ]
  }

  get EmploymentStructure (): FormStructure<EmploymentMeta> {
    return [
      {
        label: 'Name of Employer',
        key: 'nameOfEmployer'
      },
      {
        label: 'Address',
        key: 'address'
      },
      {
        label: 'From',
        key: 'dateFrom',
        type: 'date'
      },
      {
        label: 'To',
        key: 'dateTo',
        type: 'date'
      },
      {
        label: 'Designation & Department',
        key: 'designation'
      },
      {
        label: 'Brief Job Description',
        key: 'jobDescription',
        type: 'textarea',
        classes: ['colspan']
      }
    ]
  }

  formatDate (date): string {
    return date === undefined ? '' : this.dateService.format(date, 'YYYY-MM-DD')
  }

  async saveEducation () {
    this.isModalEducation = false
    const param: any = {
      adviser_oid: this.userOid,
      data: JSON.stringify(this.newEducation.convertToRawData())
    }
    if (!isEmpty(this.newEducation.oid)) {
      param.education_oid = this.newEducation.oid
    }
    const res = await this.$api.adviserDetails.saveEducation(param)
    this.newEducation.oid = res.education_oid
    this.userAdviserDetails.educationList.push(this.newEducation)
    this.newEducation = new EducationMeta()
  }

  editEducation (education: EducationMeta) {
    if (!this.isOpsStaff) return
    this.newEducation = education
    this.isModalEducation = true
  }

  async deleteEducation (id) {
    this.isModalEducation = false
    await this.$api.adviserDetails.deleteEducation({
      education_oid: id
    })
    this.userAdviserDetails.educationList = this.educationList.filter(({ oid }) => oid !== id)
  }

  async saveQualification () {
    this.isModalQualification = false
    const param: any = {
      adviser_oid: this.userOid,
      data: JSON.stringify(this.newQualification.convertToRawData())
    }
    if (!isEmpty(this.newQualification.oid)) {
      param.qualification_oid = this.newQualification.oid
    }
    const res = await this.$api.adviserDetails.saveQualification(param)
    this.newQualification.oid = res.qualification_oid
    this.userAdviserDetails.qualificationList.push(this.newQualification)
    this.newQualification = new QualificationMeta()
  }

  editQualification (qualification: QualificationMeta) {
    if (!this.isOpsStaff) return
    this.newQualification = qualification
    this.isModalQualification = true
  }

  async deleteQualification (id) {
    this.isModalQualification = false
    await this.$api.adviserDetails.deleteQualification({
      qualification_oid: id
    })
    this.userAdviserDetails.qualificationList = this.qualificationList.filter(({ oid }) => oid !== id)
  }

  async saveEmployment () {
    this.isModalEmployment = false
    const param: any = {
      adviser_oid: this.userOid,
      data: JSON.stringify(this.newEmployment.convertToRawData())
    }
    if (!isEmpty(this.newEmployment.oid)) {
      param.employment_oid = this.newEmployment.oid
    }
    const res = await this.$api.adviserDetails.saveEmployment(param)
    this.newEmployment.oid = res.employment_oid
    this.userAdviserDetails.employmentList.push(this.newEmployment)
    this.newEmployment = new EmploymentMeta()
  }

  editEmployment (employment: EmploymentMeta) {
    if (!this.isOpsStaff) return
    this.newEmployment = employment
    this.isModalEmployment = true
  }

  async deleteEmployment (id) {
    this.isModalEmployment = false
    await this.$api.adviserDetails.deleteEmployment({
      employment_oid: id
    })
    this.userAdviserDetails.employmentList = this.employmentList.filter(({ oid }) => oid !== id)
  }
}
